'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _List = require('components/List/List');

var _List2 = _interopRequireDefault(_List);

var _CoverageRecipientListItem = require('components/Statistics/CoverageRecipientListItem/CoverageRecipientListItem');

var _CoverageRecipientListItem2 = _interopRequireDefault(_CoverageRecipientListItem);

var _CoverageRecipientListHeader = require('components/Statistics/CoverageRecipientsList/CoverageRecipientListHeader');

var _CoverageRecipientListHeader2 = _interopRequireDefault(_CoverageRecipientListHeader);

var _statistics = require('helpers/statistics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./CoverageRecipientsList.scss');

var CoverageRecipientsList = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(CoverageRecipientsList, _PureComponent);

  function CoverageRecipientsList() {
    (0, _classCallCheck3.default)(this, CoverageRecipientsList);
    return (0, _possibleConstructorReturn3.default)(this, (CoverageRecipientsList.__proto__ || (0, _getPrototypeOf2.default)(CoverageRecipientsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(CoverageRecipientsList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          recipients = _props.recipients,
          columns = _props.columns,
          activeOrder = _props.activeOrder,
          order = _props.order,
          onReorder = _props.onReorder,
          projectId = _props.projectId;


      return _react2.default.createElement(
        _List2.default,
        { className: (0, _bind2.default)(styles.list, className) },
        _react2.default.createElement(_CoverageRecipientListHeader2.default, {
          activeOrder: activeOrder,
          order: order,
          onReorder: onReorder,
          columns: columns
        }),
        recipients.map(function (recipient) {
          return _react2.default.createElement(_CoverageRecipientListItem2.default, {
            key: recipient.recipientId,
            recipient: recipient,
            columns: columns,
            projectId: projectId
          });
        })
      );
    }
  }]);
  return CoverageRecipientsList;
}(_react.PureComponent), _class.propTypes = {
  activeOrder: _propTypes2.default.string,
  className: _propTypes2.default.string,
  columns: _propTypes2.default.array,
  onReorder: _propTypes2.default.func,
  order: _propTypes2.default.object,
  projectId: _propTypes2.default.number,
  recipients: _propTypes2.default.array
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  columns: _statistics.coverageRecipientsColumnsArray,
  onReorder: _noop3.default,
  recipients: []
}, _temp);
exports.default = CoverageRecipientsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/CoverageRecipientsList/CoverageRecipientsList.js
// module id = 2111
// module chunks = 1